import { ArticleJsonLd, NextSeo } from 'next-seo'
import { usePathname } from 'next/navigation'

import { Article } from 'api'
import { ArticlesSection, CTASection, WelcomeArticleSection } from 'sections/common'
import { CMS_API_BASE_URL } from 'const/config'
import { Content } from 'sections/articles/content-components'
import { checkForLandingPage } from 'components/header/default-header/utils'
import { routes } from 'utils/routes'
import { resolveUrl } from 'utils/url'
import { getBasicArticlesRoute } from 'sections/articles/page-reusable-data/funcs'

interface Props {
  article: Article
}

export const ArticlePageMain = ({ article }: Props) => {
  const pathname = usePathname()
  const { isLandingPage, landingPageType } = checkForLandingPage(pathname)

  const basicArticlesRoute = getBasicArticlesRoute(isLandingPage, landingPageType)

  return (
    <>
      <NextSeo
        title={article.title}
        description={article.description}
        openGraph={{
          type: 'article',
          title: article.title,
          images: [{ url: resolveUrl(CMS_API_BASE_URL, article.cover.url) }],
          description: article.description,
          article: {
            modifiedTime: article.updatedAt,
            authors: ['Rezitrade'],
            tags: article.tags?.map(({ title }) => title),
          },
        }}
      />
      <ArticleJsonLd
        url={routes.article(article.slug, basicArticlesRoute)}
        title={article.title}
        images={[article.cover.url]}
        datePublished={article.createdAt}
        authorName="Rezitrade"
        description={article.description}
      />

      <WelcomeArticleSection article={article} />

      {article.content_sections && <Content content={article.content_sections} />}

      {article.related_articles && article.related_articles.length > 0 && (
        <ArticlesSection title="Related articles & insights" articles={article.related_articles} />
      )}
      <CTASection />
    </>
  )
}
